import { render, staticRenderFns } from "./ArticleListing.vue?vue&type=template&id=35ec8ed0&scoped=true"
import script from "./ArticleListing.vue?vue&type=script&lang=js"
export * from "./ArticleListing.vue?vue&type=script&lang=js"
import style0 from "./ArticleListing.vue?vue&type=style&index=0&id=35ec8ed0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ec8ed0",
  null
  
)

export default component.exports